import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './MarketplaceLayout.css';

/**
 * MarketplaceLayout Component
 * Purpose: The main layout for the entire marketplace application.
 * - Includes Header, Footer, and the main content area.
 */
const MarketplaceLayout = ({
  children,
  cartItemCount,
  onSearch,
  isAuthenticated,
  user,
  onLogout,
  authLoading,
  onCartClick,
  onHomeClick
}) => {
  return (
    <div className="marketplace-layout">
      <Header
        cartItemCount={cartItemCount}
        onSearch={onSearch}
        isAuthenticated={isAuthenticated}
        user={user}
        onLogout={onLogout}
        authLoading={authLoading}
        onCartClick={onCartClick}
        onHomeClick={onHomeClick}
      />

      {/* Main Content Area */}
      <main className="marketplace-content">
        <div className="container">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default MarketplaceLayout;

